document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu]');
  if (toggle) {
    document.querySelector('[data-nav]')?.classList.toggle('is-open');
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-localization-select]');
  if (select) select.form?.submit();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.buy-now-form');
  if (!form || event.submitter?.closest('[data-shopify="payment-button"]')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button) {
    button.disabled = true;
    button.textContent = 'Going to checkout…';
  }
  try {
    await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
    const added = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!added.ok) throw new Error('Could not start checkout');
    window.location.href = '/checkout';
  } catch (error) {
    window.location.href = '/checkout';
  }
});

const syncPrice = (input) => {
  const form = input.closest('form');
  const idField = form?.querySelector('[name="id"]');
  if (idField) idField.value = input.value;
  const price = document.querySelector('[data-price]');
  if (price && input.dataset.price) price.textContent = input.dataset.price;
  const compare = document.querySelector('[data-compare]');
  if (compare) {
    compare.textContent = input.dataset.compare || '';
    compare.hidden = !input.dataset.compare;
  }
  const cta = input.dataset.cta || (input.dataset.price ? `Buy now — ${input.dataset.price}` : '');
  document.querySelectorAll('[data-buy-label], [data-sticky-cta]').forEach((el) => {
    if (cta) el.textContent = cta;
  });
  const stickyName = document.querySelector('[data-sticky-name]');
  if (stickyName && input.dataset.name) stickyName.textContent = `Onion Hydrosol ${input.dataset.name}`;
  if (input.dataset.image) {
    const main = document.querySelector('[data-main-image]');
    if (main) main.src = input.dataset.image;
  }
};

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-variant]');
  if (input) syncPrice(input);
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-thumb]');
  if (!thumb) return;
  const src = thumb.getAttribute('data-thumb');
  const main = document.querySelector('[data-main-image]');
  if (main && src) main.src = src;
  document.querySelectorAll('[data-thumb]').forEach((el) => el.classList.toggle('is-active', el === thumb));
});

document.addEventListener('click', (event) => {
  const sticky = event.target.closest('[data-sticky-cta]');
  if (!sticky) return;
  document.querySelector('.buy-now-form')?.requestSubmit();
});

const quotes = document.querySelectorAll('.quote-slide');
const dots = document.querySelectorAll('[data-quote]');
let quoteIndex = 0;
const showQuote = (index) => {
  quoteIndex = index;
  quotes.forEach((el, i) => el.classList.toggle('is-active', i === index));
  dots.forEach((el, i) => el.classList.toggle('is-active', i === index));
};
dots.forEach((dot) => {
  dot.addEventListener('click', () => showQuote(Number(dot.dataset.quote)));
});
if (quotes.length > 1) {
  setInterval(() => showQuote((quoteIndex + 1) % quotes.length), 5000);
}
